const e = {
  headers: {
    "Content-Type": "application/json"
  }
};
export {
  e as default
};
